import { useId } from "react";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

const ICON_TOGGLE_BASE =
  "flex h-9 w-9 items-center justify-center rounded-md border text-slate-600 transition";
const ICON_TOGGLE_OFF = "border-slate-200 bg-white hover:bg-slate-50";
const ICON_TOGGLE_ON =
  "border-transparent bg-slate-900 text-white hover:bg-slate-900";
/** Actif par héritage (pas de valeur posée sur cet appareil) : ton atténué. */
const ICON_TOGGLE_INHERITED =
  "border-slate-300 bg-slate-100 text-slate-700 hover:bg-slate-200";

/** Bouton-icône réutilisable avec état actif (toggle). */
export function IconToggle({
  active,
  inherited = false,
  label,
  onClick,
  children,
}: {
  active: boolean;
  /** Valeur active mais héritée d'un niveau supérieur (vue tablette / mobile). */
  inherited?: boolean;
  label: string;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      aria-label={label}
      aria-pressed={active}
      title={label}
      onClick={onClick}
      className={cn(
        ICON_TOGGLE_BASE,
        !active
          ? ICON_TOGGLE_OFF
          : inherited
            ? ICON_TOGGLE_INHERITED
            : ICON_TOGGLE_ON,
      )}
    >
      {children}
    </button>
  );
}

/** Ligne libellé + contrôle. Empilé : la sidebar Puck (~300px) trop étroite
 *  pour un layout horizontal (sinon le label se retrouve lettre-par-lettre). */
export function ControlRow({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  const labelId = useId();
  return (
    <div className="flex min-w-0 flex-col gap-2">
      <Label
        id={labelId}
        className="text-xs font-medium leading-snug text-slate-500"
      >
        {label}
      </Label>
      <div
        role="group"
        aria-labelledby={labelId}
        className="flex min-w-0 flex-wrap items-center gap-1.5"
      >
        {children}
      </div>
    </div>
  );
}
